import { StringfyDate } from "utils/date";
import translate from "utils/translations";

export const statusClasses: Record<string, string> = {
  2: "bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200",
  1: "bg-slate-200 text-slate-700 ring-1 ring-slate-300",
  5: "bg-rose-100 text-rose-800 ring-1 ring-rose-200",
};

export const getDate = function (date?: string) {
  return date
    ? StringfyDate(date)
    : translate("Unspecified_Text", "Unspecified TODO");
};
